import 'css-chunksrc/client/pages/personalSpacePage/synthesis/styles.scss';export default {
  "planzone": "_planzone_1rp2i_1",
  "title": "_title_1rp2i_7",
  "main": "_main_1rp2i_15",
  "wrapper": "_wrapper_1rp2i_21",
  "tasksColumn": "_tasksColumn_1rp2i_31",
  "tasks": "_tasks_1rp2i_31",
  "calendarColumn": "_calendarColumn_1rp2i_47",
  "horizontalResizeHandle": "_horizontalResizeHandle_1rp2i_52",
  "verticalResizeHandle": "_verticalResizeHandle_1rp2i_76",
  "unselectable": "_unselectable_1rp2i_100",
  "row": "_row_1rp2i_104",
  "header": "_header_1rp2i_110",
  "filters": "_filters_1rp2i_118",
  "resourceSelector": "_resourceSelector_1rp2i_124",
  "resourceSelectorLabel": "_resourceSelectorLabel_1rp2i_130",
  "doneTasks": "_doneTasks_1rp2i_137",
  "upComingTasksTag": "_upComingTasksTag_1rp2i_146",
  "delayedTasksTag": "_delayedTasksTag_1rp2i_155",
  "doneTasksTag": "_doneTasksTag_1rp2i_164"
};